'use client';

import { useQuery } from '@tanstack/react-query';
import { useApiClient } from '../contexts/ApiContext';
import type { RushMidConfigResponse } from '../services/generated/Api';

export type RushMidConfig = RushMidConfigResponse;

/** Per-user Rush Mid availability. Defaults to OPEN while loading/on error so a blip
 *  can't hide a live mode from everyone; the server still rejects entries if gated.
 *  The fetch starts at app boot (GlobalSubscriptions), not at screen mount, so the
 *  games tile doesn't repaint in front of the user. */
export function useRushMidConfig(): RushMidConfig {
  const apiClient = useApiClient();
  const { data } = useQuery({
    queryKey: ['rush-mid-config'],
    queryFn: () => apiClient.api.rushMidControllerGetConfig(),
    // the gates flip at deploys and admin toggles — every screen VISIT re-asks the server
    // (cached value paints instantly, the refetch corrects it), and an open screen keeps
    // itself fresh on a 60s tick so the banner appears/disappears without a reload
    staleTime: 0,
    refetchOnMount: 'always',
    refetchInterval: 60_000,
  });
  return { comingSoon: data?.comingSoon ?? false, maintenance: data?.maintenance ?? false, activeTickets: data?.activeTickets ?? [] };
}
